import React,{useState} from 'react';
import styled from 'styled-components';
import {Modal,Dropdown} from 'semantic-ui-react'



const Create = () =>{
    const [open,setOpen] = useState(false)

    return (
        <Modal
        open={open}
        onClose={()=>setOpen(false)}
        trigger={<Button onClick={()=>setOpen(true)}>Create a new analysis</Button>}
        size='small'
        >
            <Modal.Content>
                <Title>
                    Analyze a dataset
                </Title>

                <T2>Select explanatory variables</T2>
                <Description>Explanatory variables are factors that will help to predict and explain your outcome. Select as many as you think are relevant.</Description>
                <Dropdown 
                     placeholder='Select explanatory variables'
                    fluid
                    selection
                    multiple
                    options={friendOptions}/>

                <T2>Select an outcome variable</T2>
                <Description>The outcome variable is the variable you are looking to understand better.</Description>
                <Dropdown 
                     placeholder='Select an outcome variable'
                    fluid
                    selection
                    options={friendOptions2}/>


                <T2>Select data grouping</T2>
                <Dropdown 
                     placeholder='Select a data grouping'
                    fluid
                    selection
                    options={friendOptions3}/>


                <ButtonContainer>
                    <Button primary>Analyze</Button>
                </ButtonContainer>
            </Modal.Content>
        </Modal>
    )
}

export default Create

const LabelInput = styled.input`
    width:100%;
    height:40px;
    border-radius:5px;
    border:1px solid #ccc;
    padding:10px;
    margin-bottom:20px;
    font-family:'Raleway';
`
const ButtonContainer = styled.div`
    width:100%;
    margin-top:30px;
    display:flex;
    justify-content:flex-end;
`
const Button = styled.div`
    background:blue;
    color:white;
    padding:10px 20px;
    border-radius:5px;
    font-size:14px;
    font-weight:600;
    cursor:pointer;
    margin-left:20px;
`

const Title = styled.div`
    font-size:18px;
    font-weight:bold;
    margin-bottom:20px;
    font-family:'Raleway';

`

const T2 = styled.div`
    font-size:14px;
    font-weight:bold;
    font-family:'Raleway';
    margin-bottom:5px;
    margin-top:30px;
`

const Description = styled.div`
font-family:'Raleway';
margin-bottom:5px;
`

const TextArea = styled.textarea`
    width:100%;
    height:100px;
    border-radius:5px;
    border:1px solid #ccc;
    padding:10px;
    margin-top:10px;
    resize:none;
    font-family:'Raleway';
    margin-bottom:20px;
`



const friendOptions = [
    {
      key: 'Culture',
      text: 'Culture',
      value: 'Culture',
    },
    {
      key: 'Retention',
      text: 'Retention',
      value: 'Retention',
    },
    {
      key: 'Well-Being',
      text: 'Well-Being',
      value: 'Well-Being',
    },
    {
        key: 'Engagament',
        text: 'Engagament',
        value: 'Engagament',
      },
      {
        key: 'Customer Satisfaction',
        text: 'Customer Satisfaction',
        value: 'Customer Satisfaction',
      },
      {
        key: 'Store Size',
        text: 'Store Size',
        value: 'Store Size',
      }
  ]

  const friendOptions2 = [
    {
      key: 'Store P&L',
      text: 'Store P&L',
      value: 'Store P&L',
    },
    {
      key: 'Drive through performance',
      text: 'Drive through performance',
      value: 'Drive through performance',
    },
    {
      key: 'Customer retention',
      text: 'Customer retention',
      value: 'Customer retention',
    }
  ]

  const friendOptions3 = [
    {
      key: 'Store Location',
      text: 'Store Location',
      value: 'Store Location',
    },
    {
      key: 'Department',
      text: 'Department',
      value: 'Department',
    },
    {
      key: 'Market Segment',
      text: 'Market Segment',
      value: 'Market Segment',
    }
  ]